import { render, staticRenderFns } from "./add-production.vue?vue&type=template&id=3972a984&scoped=true"
import script from "./add-production.vue?vue&type=script&lang=js"
export * from "./add-production.vue?vue&type=script&lang=js"
import style0 from "./add-production.vue?vue&type=style&index=0&id=3972a984&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3972a984",
  null
  
)

export default component.exports